import { type ReactNode } from "react";

import { cn } from "#utils";

/** EmptyStateProps interface for the EmptyState component */
export interface EmptyStateProps {
  /** Message text displayed in the empty state */
  message: string;
  /** Optional title displayed above the message */
  title?: string;
  /** Optional action or content rendered below the message */
  children?: ReactNode;
  /** Additional CSS classes */
  className?: string;
}

export function EmptyState({ message, title, children, className }: EmptyStateProps) {
  if (title) {
    return (
      <div className="mt-3 grow">
        <div className="mt-10 flex items-center justify-center">
          <div
            className={cn(
              "flex h-[300px] w-1/2 flex-col items-center justify-center bg-background-primary",
              className,
            )}
          >
            <div className="mb-3">
              <h3 className="text-center text-title-medium text-text-secondary">{title}</h3>
            </div>
            <p className="text-center text-body-small text-text-secondary">{message}</p>
            {children ? <div className="mt-6">{children}</div> : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-3 grow">
      <div
        className={cn(
          "flex min-h-full flex-col items-center justify-center bg-background-secondary p-2",
          className,
        )}
      >
        <p className="text-center text-body-small text-text-secondary">{message}</p>
        {children ? <div className="mt-6">{children}</div> : null}
      </div>
    </div>
  );
}
